import axios from 'axios';

//DEV
// export const baseURL = 'http://localhost:8001'

//PRD
export const baseURL = 'https://coreapi.goshowfa.com'

export default axios.create({
    baseURL 
})